export default __webpack_public_path__ + "static/media/how-it-works-3-mob.4d2765d4.png";